import React from 'react';
import Toggle from './Toggle';
import { useTranslation } from 'react-i18next';

type UpdateCallback = (checked: boolean) => void;

interface ActivityToggleProps {
    id?: string
    onlyActive: boolean
    disabled: boolean
    update: UpdateCallback
}

const ActiveToogle: React.FC<ActivityToggleProps> = (props) => {
    const { t } = useTranslation(['common']);
    let onlyActive = props.onlyActive !== null ? !props.onlyActive : false;

    return <Toggle
        title={t('activeToggle.showInactive', { ns: 'common' })}
        value={onlyActive}
        id={`active-${props.id}`}
        disabled={props.disabled}
        update={(value) => props.update(!value)}
    />;
}

export default ActiveToogle;
